export class ResetPassword {
  password:string;
}